import { usePublicContent } from '../hooks/usePublicContent';

export const IglesiaPage = () => {
  const { getText, getJson } = usePublicContent('IGLESIA');

  const headerLabel = getText('header', 'label', 'Recursos');
  const headerTitle = getText('header', 'titulo', 'Iglesia');
  const headerSubtitle = getText('header', 'subtitulo', 'Materiales y herramientas para tu crecimiento espiritual');

  const recursos = getJson<{ titulo: string; descripcion: string; icono: string; tipo: string }[]>('recursos', 'items', [
    {
      titulo: "Biblioteca de Sermones",
      descripcion: "Accede a nuestra colección de sermones y enseñanzas bíblicas",
      icono: "📚",
      tipo: "sermones"
    },
    {
      titulo: "Estudios Bíblicos",
      descripcion: "Materiales de estudio para profundizar en la Palabra de Dios",
      icono: "📖",
      tipo: "estudios"
    },
    {
      titulo: "Música y Adoración",
      descripcion: "Himnos, coros y música cristiana para la adoración",
      icono: "🎵",
      tipo: "musica"
    },
    {
      titulo: "Recursos Familiares",
      descripcion: "Materiales para fortalecer la familia cristiana",
      icono: "👨‍👩‍👧‍👦",
      tipo: "familia"
    }
  ]);

  return (
    <div className="min-h-screen transition-colors duration-300 bg-stone-100">
      
      {/* Header */}
      <section className="relative overflow-hidden pt-32 pb-20 px-6">
        <div className="absolute inset-0 bg-stone-200/30"></div>
        <div className="relative max-w-7xl mx-auto text-center">
          <p className="text-stone-500 text-sm uppercase tracking-[0.3em] mb-3 font-medium animate-fade-in">{headerLabel}</p>
          <h1 className="text-5xl md:text-6xl font-serif font-bold mb-2 animate-fade-in text-stone-800">
            {headerTitle}
          </h1>
          <div className="w-24 h-1 bg-gradient-to-r from-purple-600 to-red-500 mx-auto mb-6 rounded-full animate-slide-up delay-100"></div>
          <p className="text-xl text-stone-600 animate-slide-up delay-200">
            {headerSubtitle}
          </p>
        </div>
      </section>

      {/* Recursos Grid */}
      <section className="py-24 px-6">
        <div className="max-w-7xl mx-auto">
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            {recursos.map((recurso, index) => (
              <div 
                key={index}
                className="bg-white rounded-2xl p-8 text-center border border-stone-200/60 shadow-sm hover:shadow-lg transition-all duration-300 animate-slide-up group"
                style={{ animationDelay: `${index * 200}ms` }}
              >
                <div className="w-16 h-16 bg-stone-100 rounded-full flex items-center justify-center mx-auto mb-6 group-hover:bg-stone-200 transition-colors">
                  <span className="text-stone-600 text-2xl">{recurso.icono}</span>
                </div>
                <h3 className="text-xl font-serif font-bold text-stone-800 mb-3">{recurso.titulo}</h3>
                <div className="w-8 h-px bg-stone-300 mx-auto mb-4"></div>
                <p className="text-stone-600 text-sm mb-6 leading-relaxed">
                  {recurso.descripcion}
                </p>
                <button className="w-full bg-purple-800 text-white py-3 px-6 rounded-xl font-semibold hover:bg-purple-700 transition-all duration-300 shadow-sm">
                  Explorar
                </button>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default IglesiaPage;
